<form [formGroup]="bankrekeningenFg">
    <div *ngIf="box3Bankrekeningen.length > 0" class="row">
        <div formArrayName="box3Bankrekeningen">
            <div *ngFor="let item of box3Bankrekeningen.controls; let i = index; "
                 [formGroupName]="i" class="row">
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Naam bank' : ''"
                                                class="custom-input-250 col-auto"
                                                formControlName="omschrijving"
                                                id="omschrijving"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-text-form-control (change)="saveForm()"
                                                [label]="i === 0 ? 'Rekeningnummer' : ''"
                                                class="me-1 custom-input-200 col-auto"
                                                formControlName="rekeningNummer"
                                                id="rekeningNummer"
                >
                </snelstart-ui-text-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Land' : ''"
                                                  [options]="optionsLandcodes"
                                                  [required]=true
                                                  class="custom-input-200 col-auto"
                                                  formControlName="landCode"
                >
                </snelstart-ui-select-form-control>
                <snelstart-ui-number-form-control (change)="saveForm()"
                                                  [decimals]="0"
                                                  [label]="i === 0 ? 'Saldo 1 januari' : ''"
                                                  [minValue]="0"
                                                  [required]=true
                                                  align="right"
                                                  class="custom-input-150 col-auto"
                                                  formControlName="bedrag"
                                                  id="bedrag"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
                <snelstart-ui-select-form-control (change)="saveForm()"
                                                  [label]="i === 0 ? 'Groene rekening' : ''"
                                                  [options]="optionsJaNee"
                                                  [required]=true
                                                  class="custom-input-150 col-auto"
                                                  formControlName="groenRekening"
                >
                </snelstart-ui-select-form-control>
                @if (this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement) {
                    <snelstart-ui-button
                            (click)="this.showDialog(i)"
                            [class]="i === 0 ? 'me-1 pt-3 custom-input-125' : 'me-1 custom-input-125'"
                            [icon]="heeftOWR[i] ? 'check' : 'plus'"
                            type="secondary">
                        OWR
                    </snelstart-ui-button>
                }
                <snelstart-ui-button (click)="verwijderRij(i)"
                                     [class]="i === 0 ? 'firstrowbutton col-auto' : 'col-auto'"
                                     icon="trash"
                                     iconType="light"
                                     id="buttonDeleteKosten"
                                     size="medium"
                                     type="secondary"
                >
                </snelstart-ui-button>
                <snelstart-ui-alert *ngIf="box3Bankrekeningen.controls[i].get('bedrag')?.value < 0" class="ps-1"
                                    style="color: red" type="danger">
                    Let op! Een bankrekening met een negatief saldo per 1
                    januari {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }} vul je niet in bij 'Bankrekeningen'.
                    Verwijder deze hier en vul deze als 'Overige schuld' in bij de schulden in box 3.
                </snelstart-ui-alert>
                <div style="width: 75%" *ngIf="!this.incomeTaxEntity.aangifte?.box3?.berekenWerkelijkRendement && box3Bankrekeningen.controls[i].get('bedrag')?.value == 0">
                    <snelstart-ui-alert
                            class="ps-1"
                            style="color: red" type="danger">
                        Let op! Een bankrekening met een saldo € 0 levert problemen op bij het indienen van de aangifte.
                        Verwijder daarom deze regel!
                    </snelstart-ui-alert>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="box3Bankrekeningen.length === 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Bankrekening invullen
    </snelstart-ui-button>
</div>
<div *ngIf="box3Bankrekeningen.length > 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button" icon="plus"
                         type="link">Bankrekening toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible"
                                [title]="getOWRDialogTitel(index)"
                                id="owrBank"
                                size="lg">
    <snelstart-ui-dialog-body>
        <form [formGroup]="bankrekeningenFg">
            <div *ngIf="box3Bankrekeningen.length > 0">
                <div formArrayName="box3Bankrekeningen">
                    <div *ngFor="let item of box3Bankrekeningen.controls; let i = index; "
                         [formGroupName]="i">
                        <div *ngIf="i === this.index">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              label="Saldo 31 december"
                                                              [minValue]="0"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="waardeEindJaar"
                                                              id="bedrag"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [minValue]="0"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="directRendement"
                                                              id="bedrag"
                                                              label="Ontvangen rente"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [required]=true
                                                              align="right"
                                                              class="custom-input-275 col-auto"
                                                              formControlName="valutaResultaat"
                                                              id="bedrag"
                                                              label="Koerswinst/-verlies"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                            <div class="pt-2">
                                <div class="d-flex align-items-center">
                                    <div class="result-inline">
                                        @let rendementBanken = getBerekendeWerkelijkRendement(i);
                                        Werkelijk rendement in {{ jaar }} =
                                        € {{ rendementBanken != null ? (rendementBanken | number:'1.0-2') : '0' }}
                                    </div>
                                </div>
                                <i>{{ getGroen(i) }}</i>
                            </div>

                            <div class="space20"></div>

                            @if (this.box3Bankrekeningen.controls[i].get('groenRekening')?.value === true) {
                                <snelstart-ui-alert type="warning">
                                    Let op! Als er in de loop van {{ this.jaar }} een groene belegging (effecten of
                                    spaartegoed)
                                    is gekocht of verkregen, hoeft het werkelijke rendement hierover nog niet opgenomen
                                    te worden in de aangifte over {{ this.jaar }}.
                                </snelstart-ui-alert>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons>
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren
        </snelstart-ui-button>
        <snelstart-ui-button btn-x icon="check" id="save" type="primary">Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>


